import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';
import { GroupTypeModel } from '@app/core/models/groups/group-type.model';
import { GroupSearchCriteriaModel } from '@app/core/models/groups/group-search-criteria.model';
import { GroupService } from '@app/core/services/group.service';
import { GroupModel } from '@app/core/models/groups/group.model';
import * as _ from 'lodash';

export abstract class AdministrationDetailBase {

    groupSearchEvent$: Subject<[GroupTypeModel, string]> = new Subject<[GroupTypeModel, string]>();
    unsubscribe$: Subject<boolean> = new Subject<boolean>();
    protected notAssignedGroupOnly: boolean = false;
    protected userId: string;
    protected searchedName: string;

    constructor(
        protected groupService: GroupService) {

        this.groupSearchEvent$
            .pipe(
                debounceTime(250),
                distinctUntilChanged(),
                tap(filterData => {
                    if (!_.isNil(filterData)) {
                        this.searchedName = filterData[1];
                        this.groupService.searchGroups('Name', 'Desc', 0, 30, {
                            IsActive: true,
                            GroupName: this.searchedName,
                            NotAssignedGroupOnly: this.notAssignedGroupOnly,
                            UserId: this.userId,
                            GroupTypes: !_.isNil(filterData[0]) ? [filterData[0]] : undefined
                        } as GroupSearchCriteriaModel)
                            .subscribe(data => {
                                this.onGroupFetched(filterData[0], data.Items);
                            });
                    }
                })).pipe(takeUntil(this.unsubscribe$)).subscribe();
    }

    public onGroupFilterChange(groupType: GroupTypeModel, data: string) {
        this.groupSearchEvent$.next([groupType, data]);
    }

    protected abstract onGroupFetched(groupType: GroupTypeModel, groups: GroupModel[]);
}
